import { Button } from "@babybjorn/ui";
import type { StoryblokRichTextNode } from "@storyblok/react";
import type { FC, ReactElement } from "react";
import RichText from "../../../../components/general/RichText";
import Icon from "../../../general/Icon/Icon";
import Link from "../../../general/Link";
import * as s from "./CategoryUspItem.module.scss";

type CategoryUspItemProperties = {
	headline?: string;
	text: string | StoryblokRichTextNode<ReactElement>;
	cta?: { label: string; link: string; icon?: string };
};

const CategoryUspItem: FC<CategoryUspItemProperties> = ({
	headline,
	text,
	cta,
}) => {
	return (
		<section className={s.container} data-id="category-usp-item">
			{headline && <h3>{headline}</h3>}
			<RichText content={text} />
			{cta?.link && (
				<div className="flex max-md:justify-center">
					<Button
						variant="secondary"
						asChild
						className="min-w-fit"
						size={cta.icon && !cta.label ? "icon" : "default"}
					>
						<Link href={cta.link}>
							{cta.icon && <Icon icon={cta.icon} color="inherit" />}
							{cta.label && <span>{cta.label}</span>}
							<span className="sr-only">Link</span>
						</Link>
					</Button>
				</div>
			)}
		</section>
	);
};

export default CategoryUspItem;
